import { CompositeLayer } from '@deck.gl/core';
import { IconLayer } from '@deck.gl/layers';
import DashedCircleLayer from './DashedCircleLayer';
import { createSVGData } from '../utils/createSVGData';

const RADIUS_SCALE = 1;
const POI_ICON_SIZE = 20;
const POI_ICON_ORIGIN_OFFSET = [0, 0];
const POI_ICON_SVG = {
  width: 40,
  height: 40,
  mask: false,
  url: createSVGData(`
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_2498_69767)">
    <circle cx="10" cy="10" r="6" fill="#F4F5FF"/>
    <circle cx="10" cy="10" r="5" stroke="#2C24C3" stroke-opacity="0.8" stroke-width="2"/>
    </g>
    <defs>
    <filter id="filter0_d_2498_69767" x="0" y="0" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2498_69767"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2498_69767" result="shape"/>
    </filter>
    </defs>
  </svg>
`),
};

export default class POICompositeLayer extends CompositeLayer {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(propObjects) {
    super(propObjects);
  }

  initializeState() {
    super.initializeState();
  }

  renderLayers() {
    const { data, getPosition, getRadius, getLineColor, getFillColor, updateTriggers } = this.props;

    return [
      new DashedCircleLayer({
        id: `${this.props.id}-circle`,
        data,
        stroked: true,
        filled: true,
        sizeUnits: 'meters',
        radiusScale: RADIUS_SCALE,
        lineWidthMinPixels: 2,
        getPosition,
        getRadius,
        getLineColor,
        getFillColor,
        updateTriggers,
      }),
      new IconLayer({
        id: `${this.props.id}-icon`,
        data,
        iconSizeScale: 1,
        sizeScale: 1,
        sizeUnits: 'pixels',
        getPixelOffset: POI_ICON_ORIGIN_OFFSET,
        getIcon: () => POI_ICON_SVG,
        getSize: () => POI_ICON_SIZE,
        getPosition,
        updateTriggers,
        pickable: true,
      }),
    ];
  }
}

POICompositeLayer.layerName = 'DirectSalesPOILayer';
